import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Observable} from 'rxjs';
import {POST_QUERY_SUCCESS_ACTION, PostQuerySuccessAction} from '@shared/store/actions/query.actions';
import {map,} from 'rxjs/operators';
import {SetTaxFormsCountriesAction} from '../actions/tax-forms.actions';
import {DoNothingAction} from '@shared/store/actions/particle.actions';

@Injectable()
export class TaxFormsEffect {
  constructor(private actions$: Actions) {
  }


  getTaxFormsCountries$ = createEffect(() => this.actions$
    .pipe( ofType(POST_QUERY_SUCCESS_ACTION) )
    .pipe(
      map((action: PostQuerySuccessAction) => {
          if (action && action.data && action.data.taxFormsCountries) {
            const allCountries = this.getConvertedCountries(action.data.taxFormsCountries);
            return new SetTaxFormsCountriesAction(allCountries);
          } else {
            return new DoNothingAction();
          }
        }
      )
    ));

  getConvertedCountries(countries: any) {
    countries = countries.map(country => {
      return {
        ...country,
        id: country.code.toLowerCase()
      };
    });
    return countries;
  }

}

